export default {
      id: "mdc_arrow_drop_down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#mdc_arrow_drop_down",
      toString: function () {
        return this.url;
      }
    }